import React from "react"
import Section from "../section"
import { Link } from "gatsby"


const Projects = [
  {
    label:'GASP Gallery',
    path:'/gasp/'
  },
  {
    label:'Foodie',
    path:'/foodie/',
  },
  {
    label:'Mailchimp',
    path:'/mailchimp/',
  }
]

const Tab = ({ label, path, isActive }) => {
 
  function addClassStyle(isActive) {   
    if (isActive) {
      return "project-label-active";
    } else {
      return "project-label"
    }
  }
  return(
    <React.Fragment>
      <Link to={path} className={addClassStyle(isActive)}> {label} </Link>
    </React.Fragment>
  )
}

const PageTabs = ({ isActive }) => {

  let currentPage = typeof window !== `undefined` ? window.location.pathname: ''; //gets current path
  
  //compares path & tab
  function checkStatus(path) {
    if (currentPage === path){
      return true;
    } else {
      return false;
    }
  }

  return (
        <div className="project-list flex row center">
            {Projects.map((project) => {
              return <Tab path={project.path} label={project.label} isActive={checkStatus(project.path)} />
            })}
        </div>
  )
}

export default PageTabs
